// extracted by mini-css-extract-plugin
export default {"button":"vj-z","reviewSort":"wj-z"};